import { Mediums } from "../../types/mediums";
import InternetMenuItems from "../internet-menu-items";
import MenuItem from "./menu-item";
import AuthContext from "../auth-context";
import { useContext } from "react";

export interface IMenuItemsProps {
  medium: Mediums | undefined;
  onShow: (isVisible: boolean) => void;
  onCollapse: (isCollapsed: boolean) => void;
}

export default function MenuItems({
  medium,
  onShow,
  onCollapse,
}: IMenuItemsProps) {
  const context = useContext(AuthContext);
  const customerInfo = context.customerInfo;

  const handleMobileClose = () => {
    if (typeof window === "undefined") return;
    const isMobile = window.innerWidth < 1200;
    if (isMobile) {
      onShow(false);
      onCollapse(false);
    }
  };

  return (
    <nav aria-label="Main">
      <ul className="nav flex-column mt-2">
        <MenuItem
          title="داشبورد"
          to="/"
          active
          fadeable
          icon="tachometer-alt"
          iconBgc="primary-tp1"
          onShow={handleMobileClose}
          onCollapse={handleMobileClose}
        />
        {customerInfo?.user != null &&
          customerInfo.company?.nationalIdentity != null && (
            <MenuItem
              title="افراد مرتبط"
              to="/contacts"
              icon="user"
              iconBgc="orange-tp1"
              onShow={handleMobileClose}
              onCollapse={handleMobileClose}
            />
          )}

        <MenuItem
          title="لیست سرویس ها"
          to="/services"
          icon="file"
          iconBgc="red-tp1"
          fadeable
          onShow={handleMobileClose}
          onCollapse={handleMobileClose}
        />

        <MenuItem
          title="مالی"
          icon="money-bill-wave"
          iconBgc="green-tp1"
          fadeable
          onShow={handleMobileClose}
          onCollapse={handleMobileClose}
        >
          <MenuItem
            title="خریدها"
            to="/withdraws"
            fadeable
            onShow={handleMobileClose}
            onCollapse={handleMobileClose}
          />
          <MenuItem
            title="پرداخت ها"
            to="/payments"
            fadeable
            onShow={handleMobileClose}
            onCollapse={handleMobileClose}
          />
          {customerInfo?.user != null && (
            <>
              <MenuItem
                title="ثبت فیش بانکی"
                to="/registerBankReceipt"
                fadeable
                onShow={handleMobileClose}
                onCollapse={handleMobileClose}
              />
            </>
          )}
        </MenuItem>

        {(medium === Mediums.ADSL || medium === Mediums.TdLte) && (
          <InternetMenuItems
            onShow={handleMobileClose}
            onCollapse={handleMobileClose}
          />
        )}
      </ul>
    </nav>
  );
}
